import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import type { RequestDocAttachmentDto } from '../models/requestDocAttachment';

/**
 * The documents already saved on a draft, each with a button to remove it.
 * New documents are chosen with the form's own file picker and uploaded when the draft is saved.
 */
@Component({
    selector: 'xp-draft-documents',
    standalone: true,
    imports: [MatButtonModule, MatIconModule, MatTooltipModule],
    template: `
        @if (documents().length > 0) {
        <div class="saved-documents">
            <div class="heading">Documents saved on this draft</div>
            @for (document of documents(); track document.id) {
            <div class="document">
                <mat-icon class="file-icon">attach_file</mat-icon>
                <span class="name">{{ document.fileName }}</span>
                <span class="size">{{ document.fileSize }}</span>
                <button type="button" mat-icon-button color="warn" matTooltip="Remove this document"
                        [attr.aria-label]="'Remove ' + document.fileName"
                        (click)="remove.emit(document.id)">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            }
        </div>
        }
    `,
    styles: [`
        :host { display: block; width: 100%; }
        .saved-documents { margin: 4px 0 12px; }
        .heading { font-size: 13px; opacity: 0.75; margin-bottom: 4px; }
        .document { display: flex; align-items: center; gap: 8px; }
        .name { flex: 1 1 auto; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
        .size { opacity: 0.7; font-size: 13px; }
        .file-icon { font-size: 18px; width: 18px; height: 18px; }
    `]
})
export class DraftDocumentsComponent {
    /** The documents saved on the draft. */
    readonly documents = input<RequestDocAttachmentDto[]>([]);

    /** Raised with the document's id when the user removes it. */
    readonly remove = output<number>();
}
